interface IUrlPolyfill {
  parse(this: IUrlPolyfill, url: string, base?: string): URL | null;
  canParse(this: IUrlPolyfill, url: string, base?: string): boolean;
}

const polyfill: IUrlPolyfill = {
  canParse(url: string, base?: string): boolean {
    try {
      // oxlint-disable-next-line no-new
      new URL(url, base);
    } catch {
      return false;
    }
    return true;
  },
  parse(url: string, base?: string): URL | null {
    return this.canParse(url, base) ? new URL(url, base) : null;
  },
};

if (!('canParse' in URL)) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  (URL as IUrlPolyfill).canParse = polyfill.canParse;
}

if (!('parse' in URL)) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  (URL as IUrlPolyfill).parse = polyfill.parse;
}

export { polyfill };
